var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    !!this.$slots["top"]
      ? _c("div", { staticClass: "layout__top" }, [_vm._t("top")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          container: _vm.type !== "wide",
          layout__container: _vm.type === "two-columns",
        },
        staticStyle: { overflow: "hidden" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "layout__content",
              class: {
                "col-default-12": _vm.type === "one-column",
                "col-default-8 col-tablet-12": _vm.type === "two-columns",
                "col-default-12 layout__content--wide": _vm.type === "wide",
              },
            },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _vm.type === "two-columns"
            ? _c(
                "aside",
                {
                  staticClass:
                    "layout__aside col-default-3 col-default-offset-1 hide-me--tablet",
                },
                [_vm._t("aside")],
                2
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }